import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  AddAngelInvestmentInvitationUseCaseInput,
  AddAngelInvestmentInvitationUseCaseOutput,
  IAddAngelInvestmentInvitationUseCase,
  IAppErrorFactory,
  IInvitationsService,
} from '../../types'

@injectable()
export default class AddAngelInvestmentInvitationInteractor implements IAddAngelInvestmentInvitationUseCase {
  @inject(symbols.IInvitationsService) private invitationsService: IInvitationsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddAngelInvestmentInvitationUseCaseInput): Promise<AddAngelInvestmentInvitationUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.invitationLink = await this.invitationsService.addAngelInvestmentInvitation(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): AddAngelInvestmentInvitationUseCaseOutput {
    return {
      invitationLink: null,
      error: null,
    }
  }
}
